import CandidatePortal from "./layouts/CandidatePortal";
import "bootstrap/dist/css/bootstrap.min.css";
import "../App.css";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Login from "../components/auth/pages/Login";
import Register from "../components/auth/pages/Register";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import ForgotPassword from "../components/auth/pages/ForgotPassword";
import DigiLockerCallback from "../components/profile/pages/DigiLockerCallback.js";
import "@fontsource/poppins";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/300.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/700.css";
import PrivateRoute from "../components/auth/pages/PrivateRoute";
import { useState } from "react";
import CustomChatbot from "../components/integrations/chatbot/CustomChatbot";
import OtpVerification from "../components/auth/pages/OtpVerification";
import ChangePasswordVerification from "../components/auth/pages/ChangePasswordVerification";
import ChangePassword from "../components/auth/pages/ChangePassword";
import Oppurtunities from "../components/jobs/pages/Oppurtunities";
import PaymentSuccess from "../components/jobs/components/PaymentSuccess";
import PaymentFailed from "../components/jobs/components/PaymentFailed";
import SessionManager from "./SessionManager";
import EmployeeOnboardingForm from "../components/jobs/pages/EmployeeOnboardingForm";
import { useEffect } from "react";
import usePortalConfig from "../hooks/usePortalConfig";
import { useNavigate } from "react-router-dom";

function App() {
  const location = useLocation();
  const { portal, config } = usePortalConfig();
  const navigate = useNavigate();

  const showChat = ![
    "/sagarsoft/candidate-portal",
    "/sagarsoft/forgot-password",
    "/sagarsoft/register",
    "/sagarsoft/login",
    "/sagarsoft/otp-verification",
    "/sagarsoft/change-password-verification",
    "/sagarsoft/change-password",
  ].includes(location.pathname);

  const [chatOpen, setChatOpen] = useState(false);

  const toggleChat = () => {
    setChatOpen(!chatOpen);
  };

  useEffect(() => {
    document.title = config.appTitle;

    const favicon = document.querySelector("link[rel='icon']");
    if (favicon) {
      favicon.href = config.favicon;
    }

    const appleIcon = document.querySelector("link[rel='apple-touch-icon']");
    if (appleIcon) {
      appleIcon.href = config.favicon;
    }
  }, [config]);

  useEffect(() => {
    const urlPortal = location.pathname.split("/")[1];
    const validPortals = ["bob", "pnb", "sagarsoft"];

    if (!validPortals.includes(urlPortal)) return;

    // Always use the portal from the URL
    localStorage.setItem("portal", urlPortal);
  }, [location.pathname]);

  return (
    <div className="App">
      <Routes>
        {/* Default redirect */}
        {/* <Route path="/" element={<Navigate to="/candidate-portal" replace />} /> */}
        <Route path="/" element={<Navigate to="/sagarsoft/login" replace />} />

        {/* Public routes */}
        <Route path="/bob/current-oppurtunities" element={<Oppurtunities />} />
        <Route
          path="/bob/employee-onboarding"
          element={<EmployeeOnboardingForm />}
        />
        {/* <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/otp-verification" element={<OtpVerification />} /> */}


        {/* BOB */}
        <Route path="/bob/login" element={<Login />} />
        <Route path="/bob/register" element={<Register />} />
        <Route path="/bob/forgot-password" element={<ForgotPassword />} />
        <Route path="/bob/otp-verification" element={<OtpVerification />} />

        {/* PNB */}
        <Route path="/pnb/login" element={<Login />} />
        <Route path="/pnb/register" element={<Register />} />
        <Route path="/pnb/forgot-password" element={<ForgotPassword />} />
        <Route path="/pnb/otp-verification" element={<OtpVerification />} />

        <Route path="/pnb/current-oppurtunities" element={<Oppurtunities />} />
        <Route
          path="/pnb/employee-onboarding"
          element={<EmployeeOnboardingForm />}
        />

        {/* Sagarsoft */}
        <Route path="/sagarsoft/login" element={<Login />} />
        <Route path="/sagarsoft/register" element={<Register />} />
        <Route path="/sagarsoft/forgot-password" element={<ForgotPassword />} />
        <Route path="/sagarsoft/otp-verification" element={<OtpVerification />} />
        <Route path="/sagarsoft/current-oppurtunities" element={<Oppurtunities />} />
        <Route
          path="/sagarsoft/employee-onboarding"
          element={<EmployeeOnboardingForm />}
        />

        <Route
          path="/sagarsoft/change-password-verification"
          element={<ChangePasswordVerification />}
        />
        <Route path="/sagarsoft/change-password" element={<ChangePassword />} />

        {/* Protected routes */}
        <Route element={<PrivateRoute />}>
          {/*  SessionManager layer */}
          <Route element={<SessionManager />}>
            {/* <Route path="/candidate-portal" element={<CandidatePortal />} />
            <Route
              path="/candidate-portal/:requisitionId"
              element={<CandidatePortal />}
            />
            <Route
              path="/candidate-portal/:requisitionId/:positionId"
              element={<CandidatePortal />}
            /> */}

            {/* BOB */}
            <Route path="/bob/candidate-portal" element={<CandidatePortal />} />
            <Route
              path="/bob/candidate-portal/:requisitionId"
              element={<CandidatePortal />}
            />
            <Route
              path="/bob/candidate-portal/:requisitionId/:positionId"
              element={<CandidatePortal />}
            />

            {/* PNB */}
            <Route path="/pnb/candidate-portal" element={<CandidatePortal />} />
            <Route
              path="/pnb/candidate-portal/:requisitionId"
              element={<CandidatePortal />}
            />
            <Route
              path="/pnb/candidate-portal/:requisitionId/:positionId"
              element={<CandidatePortal />}
            />

            {/* Sagarsoft */}
            <Route path="/sagarsoft/candidate-portal" element={<CandidatePortal />} />
            <Route
              path="/sagarsoft/candidate-portal/:requisitionId"
              element={<CandidatePortal />}
            />
            <Route
              path="/sagarsoft/candidate-portal/:requisitionId/:positionId"
              element={<CandidatePortal />}
            />


            <Route
              path="/sagarsoft/candidate-portal/payment-success"
              element={<PaymentSuccess />}
            />
            <Route
              path="/sagarsoft/candidate-portal/payment-failed"
              element={<PaymentFailed />}
            />
            {/* <Route
              path="/digilocker-upload-callback"
              element={<CandidatePortal />}
            /> */}

            <Route
              path="/sagarsoft/digilocker-upload-callback"
              element={<DigiLockerCallback />}
            />
          </Route>
        </Route>

        {/* Catch-all */}
        {/* <Route path="*" element={<Navigate to="/login" replace />} /> */}
        <Route path="*" element={<Navigate to="/sagarsoft/login" replace />} />
      </Routes>

      <ToastContainer position="top-right" autoClose={3000} />

      {showChat && <CustomChatbot isOpen={chatOpen} onToggle={toggleChat} />}
    </div>
  );
}

export default App;


// import CandidatePortal from "./layouts/CandidatePortal";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "../App.css";
// import { Navigate, Route, Routes, useLocation } from "react-router-dom";
// import Login from "../components/auth/pages/Login";
// import Register from "../components/auth/pages/Register";
// import "react-toastify/dist/ReactToastify.css";
// import { ToastContainer } from "react-toastify";
// import ForgotPassword from "../components/auth/pages/ForgotPassword";
// import DigiLockerCallback from "../components/profile/pages/DigiLockerCallback.js";
// import "@fontsource/poppins";
// import "@fontsource/poppins/600.css";
// import "@fontsource/poppins/300.css";
// import "@fontsource/poppins/500.css";
// import "@fontsource/poppins/700.css";
// import PrivateRoute from "../components/auth/pages/PrivateRoute";
// import { useState } from "react";
// import CustomChatbot from "../components/integrations/chatbot/CustomChatbot";
// import OtpVerification from "../components/auth/pages/OtpVerification";
// import ChangePasswordVerification from "../components/auth/pages/ChangePasswordVerification";
// import ChangePassword from "../components/auth/pages/ChangePassword";
// import Oppurtunities from "../components/jobs/pages/Oppurtunities";
// import PaymentSuccess from "../components/jobs/components/PaymentSuccess";
// import PaymentFailed from "../components/jobs/components/PaymentFailed";
// import SessionManager from "./SessionManager";
// import EmployeeOnboardingForm from "../components/jobs/pages/EmployeeOnboardingForm";
// import { useEffect } from "react";
// import { PORTALS } from "../config/portalConfig";


// function App() {
//   const location = useLocation();

//   const showChat = ![
//     "/careers-portal",
//     "/forgot-password",
//     "/register",
//     "/login",
//     "/pnb/login",
//     "/pnb/register",
//     "/pnb/forgot-password",
//     "/pnb/otp-verification",
//     "/",
//     // BOB
//     "/bob/login",
//     "/bob/register",
//     "/bob/forgot-password",
//     "/bob/otp-verification",

//     // PNB
//     "/pnb/login",
//     "/pnb/register",
//     "/pnb/forgot-password",
//     "/pnb/otp-verification",
//   ].includes(location.pathname);

//   const [chatOpen, setChatOpen] = useState(false);

//   const toggleChat = () => {
//     setChatOpen(!chatOpen);
//   };


// const isPnb = location.pathname.startsWith("/pnb");

//   const config = isPnb ? PORTALS.pnb : PORTALS.bob;

//   useEffect(() => {
//     document.title = config.appTitle;

//     const favicon = document.querySelector("link[rel='icon']");
//     if (favicon) {
//       favicon.href = config.favicon;
//     }

//     const appleIcon = document.querySelector("link[rel='apple-touch-icon']");
//     if (appleIcon) {
//       appleIcon.href = config.favicon;
//     }
//   }, [config]);

//   return (
//     <div className="App">
//       <Routes>
//         {/* Default redirect */}
//         <Route path="/" element={<Navigate to="/bob/login" replace />} />

//         {/* Public Routes */}
//         <Route path="/current-oppurtunities" element={<Oppurtunities />} />

//         <Route
//           path="/employee-onboarding"
//           element={<EmployeeOnboardingForm />}
//         />

//         {/* BOB */}
//         <Route path="/bob/login" element={<Login />} />
//         <Route path="/bob/register" element={<Register />} />
//         <Route path="/bob/forgot-password" element={<ForgotPassword />} />
//         <Route path="/bob/otp-verification" element={<OtpVerification />} />

//         {/* RMS */}
//         <Route path="/pnb/login" element={<Login />} />
//         <Route path="/pnb/register" element={<Register />} />
//         <Route path="/pnb/forgot-password" element={<ForgotPassword />} />
//         <Route path="/pnb/otp-verification" element={<OtpVerification />} />

//         {/* Common */}
//         <Route
//           path="/change-password-verification"
//           element={<ChangePasswordVerification />}
//         />

//         <Route
//           path="/change-password"
//           element={<ChangePassword />}
//         />

//         {/* Protected Routes */}
//         <Route element={<PrivateRoute />}>
//           <Route element={<SessionManager />}>
//             {/* <Route
//               path="/candidate-portal"
//               element={<CandidatePortal />}
//             />

//             <Route
//               path="/candidate-portal/:requisitionId"
//               element={<CandidatePortal />}
//             />

//             <Route
//               path="/candidate-portal/:requisitionId/:positionId"
//               element={<CandidatePortal />}
//             /> */}

//             {/* BOB */}
//             <Route
//               path="/bob/candidate-portal"
//               element={<CandidatePortal />}
//             />

//             <Route
//               path="/bob/candidate-portal/:requisitionId"
//               element={<CandidatePortal />}
//             />

//             <Route
//               path="/bob/candidate-portal/:requisitionId/:positionId"
//               element={<CandidatePortal />}
//             />

//             {/* PNB */}
//             <Route
//               path="/pnb/candidate-portal"
//               element={<CandidatePortal />}
//             />

//             <Route
//               path="/pnb/candidate-portal/:requisitionId"
//               element={<CandidatePortal />}
//             />

//             <Route
//               path="/pnb/candidate-portal/:requisitionId/:positionId"
//               element={<CandidatePortal />}
//             />

//             <Route
//               path="/candidate-portal/payment-success"
//               element={<PaymentSuccess />}
//             />

//             <Route
//               path="/candidate-portal/payment-failed"
//               element={<PaymentFailed />}
//             />

//             <Route
//               path="/digilocker-upload-callback"
//               element={<DigiLockerCallback />}
//             />
//           </Route>
//         </Route>

//         {/* Catch All */}
//         <Route path="*" element={<Navigate to="/bob/login" replace />} />
//       </Routes>

//       <ToastContainer position="top-right" autoClose={3000} />

//       {showChat && (
//         <CustomChatbot
//           isOpen={chatOpen}
//           onToggle={toggleChat}
//         />
//       )}
//     </div>
//   );
// }

// export default App;
